// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1jeee","productName":"Table_productName__2-CiJ"};